import * as catalogos from './catalogos/nl';
export const locale = {
  lang: 'nl',
  data: {
    'CERTIFICARV3': {
      'GUAR_CAMB': 'Besparing van veranderingen..',
      'CATALOGOS': {
        'SECCIONES': catalogos.secciones,
        'PREGUNTAS': catalogos.preguntas,
        'ABIERTAS': catalogos.abiertas,
        'PREG_ESPECI': catalogos.preguntasEspeciales,
      },
      'TITULO_TAB_PREG': 'Vragen',
      'TITULO_TAB_TRAD': 'Vertaling',
      'TITULO_TAB_PREV': 'Preview',
      'TAB_PREGUNTAS':{
        'CLA':'Clave:',
        'BTN_CONFIG_PLA': 'Sjabloonconfiguratie',
        'SLI_VER_US_EMPRE': 'Bekijk als zakelijke gebruiker',
        'ETI_INSTNES': 'U kunt een lijst met vragen in een sjabloon laden volgens deze stappen:',
        'ETI_INST1': 'Download het sjabloon',
        'ETI_INST2': 'Vul het sjabloon in met de vragen volgens het formaat',
        'ETI_INST3': 'Laad het sjabloon met de vragen',
        'ETI_INST_NOT': 'Opmerking: u kunt een lijst met vragen uploaden op een algemene manier of binnen elke beschikbare sectie',
        'ETI_SECCI_NOT_GRU': 'Deze sectie heeft geen groep',
        'INST_AGRE_GRUP': 'Voeg een groep vragen toe met de volgende knop',
        'BTN_AGRE_GRUP': 'Voeg een groep toe',
        'INST2_AGRE_GRUP': 'U kunt later vragen toevoegen aan deze groep',
        'ETI_DETEC_CAMB_PLAN': 'Er zijn wijzigingen in het oorspronkelijke sjabloon gedetecteerd',
        'BTN_GUAR_CAMB': 'Wijzigingen opslaan',
        'BTN_GUAR_CAMB_NEW_PLAN': 'Opslaan als nieuw sjabloon',
        'MAT_DESC_PLAN': 'Download sjabloon',
        'ETI_LIS_GRUP': 'Groepslijst',
        'MAT_CHIP_PRE_EXTR_SI': 'Extra vragen beschikbaar: ',
        'MAT_CHIP_PRE_EXTR_NO': 'U kunt geen extra vragen meer toevoegen',
        'MAT_CHIP_PRE_EXTR_ILIM': 'Onbeperkte extra vragen',
        'ETI_INST_COLO_CUR': 'Plaats de cursor op een willekeurige groep om de beschikbare acties te zien',
        'MAT_EDIT_NOMB_SECC': 'Bewerk de naam van de groep',
        'MAT_DELET_SECC': 'Verwijder deze groep',
        'MAT_AGRE_SECC_ARRI': 'Voeg een groep toe',
        'ETI_SECC_SIN_PREG': 'Deze groep heeft geen vragen',
        'ETI_SECC_INST_COLO_CUR': 'Plaats de cursor op een vraag om de beschikbare acties te zien',
        'ETI_PREG_OPCIO_EDITA': 'Facultatieve bewerkbare vraag',
        'ETI_PREG_OPCIO_NO_EDITA': 'Facultatieve niet-wijzigbare vraag',
        'ETI_PREG_OPCIO_OBLI_EDITA': 'Verplichte bewerkbare vraag',
        'ETI_PREG_OPCIO_OBLI_NO_EDITA': 'Verplichte niet-wijzigbare vraag',
        'ETI_PREG_RESP_OBLI_NO_EDITA':'Antwoord op de vraag',
        'MAT_FALT_OPC_RESP': 'Antwoordopties ontbreken',
        'ETI_FALT_OPC_RESP': 'Vraag ontbrekende antwoordopties',
        'MAT_NO_GUAR_CATA': 'Nog niet opgeslagen in de catalogus',
        'ETI_PREG_NO_GUAR_CATA': 'Vraag nog niet opgeslagen in de catalogus',
        'MAT_CHIP_TIP': 'type',
        'MAT_TOOL_DETA_PREG': 'Detail van de vraag',
        'BTN_EDIT_PREG': 'Zie de details',
        'MAT_TOOL_MOVE_PREG': 'Verplaats deze vraag',
        'BTN_EDIT_ES_PREG': 'Bewerk deze vraag',
        'BTN_DELE_ES_PREG': 'Verwijder deze vraag',
        'MAT_TOOL_AGRE_PREG_ARRI': 'Voeg vraag toe',
        'MAT_TOOL_AGRE_PREG_ABAJ': 'Voeg onderstaande vraag toe',
        'MAT_LABE_SELE_VERSI_PREG': 'Selecteer een versie van de vraag',
        'MAT_LABE_TEX_PREG': 'Vraagtekst',
        'MAT_LABE_TEX_PREG_KEY':'Sleutel voor speciale vragen',
        'ETI_CUE_SIG_ACC_PREG': 'Reken op de volgende acties voor deze vraag',
        'MAT_CARD_MAES': 'Hoofdcatalogus',
        'ETI_DETEC_CAMB_TEX_PREG': 'Er zijn wijzigingen in de vraagtekst geconstateerd',
        'MAT_TOOL_YET_NO_GUA_CAT': 'Nog niet opgeslagen in de catalogus',
        'ETI_ESTA_PREG_NO_GUAR_CATA': 'Deze vraag wordt niet opgeslagen in de catalogus',
        'ETI_GUAR_PREG': 'Vraag opslaan',
        'ETI_GUAR_CAMB': 'Wijzigingen opslaan',
        'MAT_SLIDE_PREG_EDIT': 'Bewerkbare vraag',
        'MAT_SLIDE_PREG_DELET': 'Verwijderbare vraag',
        'MAT_SLIDE_PREG_REQUI': 'Verplicht antwoord',
        'ETI_AGRE_PREG': 'Voeg een vraag toe',
        'ETI_GRUP_PREG': 'Groep van vragen',
        'ETI_SECC_ESP': 'Speciale Sectie',
        'ETI_KEY_NO_EMPL': 'Sleutel voor speciale sectie niet gebruikt',
        'ETI_FALT_KEY_SEC_ESP': '*Speciale sectiesleutel ontbreekt',
        'ETI_CLA_GRU_LIS':'Trefwoord:',
        'DIALOG_MODAL':{
          'ETI_MOVE_PREG': 'Verplaats vraag',
          'ETI_INTS_SELEC_SECC_MOVE': 'Selecteer de groep waar u de vraag naartoe wilt verplaatsen',
          'ETI_NOT_PREG_MOVE1': 'NOOT:',
          'ETI_NOT_PREG_MOVE2': 'De vraag wordt verplaatst naar het einde van de geselecteerde groep',
          'BTN_CANCELAR': 'Annuleren',
          'ETI_CONFI_PLAN': 'Sjabloonconfiguratie',
          'ETI_DATOS_PLAN': 'Sjabloongegevens:',
          'ETI_NOMB': 'Naam:',
          'ETI_SECC': 'Groepen:',
          'ETI_PREG': 'Vragen:',
          'ETI_NOT_CONF_CONT_SECC':'OPMERKING: De configuratie van deze bedieningselementen geldt voor alle groepen en vragen in het sjabloon in de weergavemodus als een gebruiker van het bedrijfstype.',
          'ETI_PERMI_SECC': 'Groepsvergunningen',
          'ETI_AGRE_SECC_NEW': 'Nieuwe groepen toevoegen',
          'ETI_MOVE_SECC': 'Verplaats groepen',
          'ETI_EDIT_TITU': 'Titel bewerken',
          'ETI_DELET_SECC': 'Groepen verwijderen',
          'ETI_NOMB_OBL_GRUP_NEW':'Verplichte namen in nieuwe groepen',
          'ETI_ENABLE_SEC_ESP': 'Speciale vragen / secties inschakelen',
          'ETI_PERMIS_PREG': 'Toestemming om vragen te stellen aan elke groep:',
          'ETI_AGRE_PREG_NEW': 'Nieuwe vragen toevoegen',
          'ETI_AGRE_PREG_CATAL': 'Catalogusvragen toevoegen',
          'ETI_MOVE_PREGS': 'Verplaats vragen',
          'ETI_EDIT_PREG': 'Bewerk vragen',
          'ETI_DELET_PREG': 'Vragen verwijderen',
          'ETI_PREG_NEW_MAX': 'Nieuwe maximumvragen',
          'ETI_MAX_PREG_NEW': 'Maximaal aantal nieuwe vragen',
          'ETI_ENABLE_AUDIOS': 'Audiotracks inschakelen',
          'ETI_DEMOGRAF': 'Demografie',
          'ETI_ABIER': 'Open',
          'ETI_PRAC4ALL': 'Practices 4All',
          'ETI_ADICIO': 'Extra',
          'BTN_SAL': 'Exit',
          'ETI_INST_AGRE_PREG_CAT': 'Catalogusvraag toevoegen',
          'ETI_BUSC_SELECC_PREG_PLAN': 'In dit scherm kunt u zoeken en vragen selecteren om toe te voegen aan het sjabloon',
          'TITULO_TAB_LIS_PREG':'Lijst van vragen',
          'TITULO_TAB_BUSC_PREG':'Zoekvraag',
          'TITULO_TAB_PREG_SELEC':'Geselecteerde vragen',
          'PASO_1':'Stap 1',
          'PASO_2':'Stap 2',
          'ETI_VER_LIS_PREG_SELEC_3_PEST': 'U kunt de lijst met geselecteerde vragen zien in het derde tabblad van dit venster',
          'ETI_SELEC_PREG_LIS_CAT': 'Selecteer de vraag uit de lijst in de catalogus',
          'ETI_SELEC_PREG': 'Selecteer een vraag',
          'ETI_YA_SELEC_NUM_MAX_PREG': 'U hebt het maximum aantal extra vragen dat in het sjabloon is toegestaan al geselecteerd',
          'ETI_PREG_MS_UNA_VERS': 'Deze vraag heeft meer dan één versie, selecteer de versie die u wilt bekijken',
          'ETI_SELEC_VERS': 'Selecteer een versie',
          'ETI_PREG_SELECCIONDA': 'Geselecteerde vraag:',
          'ETI_AGRE_PREG': 'Vraag toevoegen',
          'ETI_OK_AGRE_PREG_LIST':'<b>De vraag is toegevoegd aan de lijst met vragen</b>, u kunt kiezen en meer vragen toevoegen aan het sjabloon',
          'ETI_OK_AGRE_PREG_LIST2': 'U kunt de lijst met geselecteerde vragen ook zien in het derde tabblad van dit venster',
          'ETI_ESCR_TEXT_BUSC': 'Voer de tekst in van de vraag die u wilt zoeken',
          'ETI_BUSC_PREG_COINC': 'Zoeken naar passende vragen',
          'ETI_NO_ENCO_PREG': 'Er zijn geen vragen gevonden bij de ingevoerde tekst, probeer een andere tekst',
          'ETI_RESUL_BUSC': 'Zoekresultaten',
          'BTN_ELEG': 'Kies',
          'ETI_REGRE_RESUL': 'Terug naar de resultaten',
          'ETI_PREG_SELECC_MOMEN': 'Lijst van tot nu toe geselecteerde vragen',
          'MAT_TOOL_ELEG_VERSI': 'Kies een andere versie',
          'MAT_TOOL_ELI_VERSI':'Verwijder versie',
          'BTN_REGRES': 'Terugkeer',
          'BTN_ELIG_VERSI': 'Kies versie',
          'MAT_TOOL_QUITA_LIS': 'Verwijder van de lijst',

          'BY_TEXT': 'Per vraagtekst',
          'BY_KEYWORDS': 'op trefwoorden',
          'QUESTION_TEXT': 'Vraagtekst',
          'QUESTION_KEYWORDS': 'Trefwoorden',
          'QUESTION_HINT': 'Trefwoorden moeten beginnen met het teken <b> # </b> en gescheiden worden door komma\'s'
        },
        'DETALLE':{
          'ETI_DETALL_PREG': 'Detail van de vraag',
          'ETI_LAB_TEX_PREG': 'Vraagtekst',
          'PLACE_HOL_TEX_PREG': 'Vraagtekst',
          'MAT_TOOL_EDIT_PREG': 'Bewerk deze vraag',
          'MAT_CARD_OPC_RESP': 'Response-opties',
          'MAT_TOOL_EDIT_RESP': 'Bewerk dit antwoord',
          'MAT_TOOL_DELET_RESP': 'Verwijder dit antwoord',
          'ETI_AGRE_OPCI_RESP': 'Voeg een antwoordoptie toe',
          'ETI_SELEC_VERSI_PREG': 'Selecteer een versie van de vraag',
          'ETI_CUENT_SIG_ACC_PREG': 'Reken op de volgende acties voor deze vraag',
          'ETI_DETEC_CAMB_TEXMAES': 'Hoofdcatalogus',
          'ETI_CATA_MAES': 'Hoofdcatalogus',
          'ETI_DETEC_CAMB_TEX_PREG': 'Er zijn wijzigingen in de vraagtekst geconstateerd',
          'ETI_DETEC_CAMB_TEX_RESP': 'Veranderingen in antwoordopties gedetecteerd',
          'ETI_PREG_NO_GUAR_CATA': 'Deze vraag wordt niet opgeslagen in de catalogus',
          'ETI_GUAR_PREG': 'Vraag opslaan',
          'ETI_GUAR_CAMB': 'Wijzigingen opslaan',
          'ETI_BORR_PREGUN':'Vraag verwijderen',
          'ETI_DELET_PREG': 'Vraag verwijderen',
          'MAT_CARD_PLAN': 'Sjabloon',
          'MAT_SLIDE_PREG_EDIT': 'Bewerkbare vraag',
          'MAT_SLIDE_PREG_DELET': 'Verwijderbare vraag',
          'MAT_SLIDE_PREG_REQUI': 'Verplicht antwoord',
          'BTN_REGRES': 'Terugkeer',
          'ETI_NEW_PREG': 'Nieuwe vraag',
          'ETI_ESCR_TEXT_SELEC_TIP_PRE': 'Typ de tekst en selecteer het type antwoord voor de nieuwe vraag',
          'ETI_ESCR_TEXT_AGRE_OPCI_RESP': 'Schrijf de tekst en voeg antwoordopties toe voor de nieuwe vraag',
          'ETI_TIP_PREG': 'Vraagtype',
          'ETI_TIP_RESP': 'Type reactie',
          'ETI_TIP_FORM':'Vraag formaat',
          'ETI_PREG_ESP_FLD': 'Sleutel voor speciale vraag',
          'ETI_PREG_ESP_HNT': 'Voer de sleutel in voor de speciale vraag',
          'BTN_CANCELAR': 'Annuleren',
          'BTN_CONTINU': 'Ga door',
          'ETI_NEW_PRAC_4ALL': 'New 4All practice',
          'ETI_INST_NAME_DESC_4ALL': 'Voer de naam en de beschrijving van de nieuwe 4All-praktijk in',
          'ETI_LABE_NAME': 'Praktijknaam',
          'ETI_LABE_DESC': 'Beschrijving van de praktijk',
          'ETI_CLAVE_DEMOGR': 'Schrijf een of meer trefwoorden die de vraag identificeren, te beginnen met het teken',
          'ETI_CLAVE_DEMOGR1': 'en gescheiden door kommas',
          'ETI_CLAVE_DEMOGR2': 'OPMERKING: trefwoorden worden alleen opgeslagen als u deze vraag opslaat in de catalogus wanneer u dit venster sluit',
          'ETI_PALA_CLAVE_DEMOGR': 'Trefwoorden',
          'ETI_SELE_TIPO_DEMOGR': 'Selecteer het type demografie dat overeenkomt met de nieuwe vraag',

          'MAT_TOOL_CONFIG_RESP':'Configureer dit antwoord',
          'MAT_SLIDE_RESP_EDIT':'Bewerkbaar antwoord',
          'MAT_SLIDE_RESP_DELET':'Verwijderbaar antwoord',
          'MAT_SLIDE_RESP_TIPO_OTRO':'Typ "Anders"',
          'MAT_TOOL_NEWVERS_PREG':'Bewaar als nieuwe versie',
          'NOTA_PREG_MOD': 'OPMERKING: De tekst van deze vraag is aangepast, u kunt deze desgewenst opslaan als een nieuwe versie',
          'RESPUESTA_TIPO_OTRO':' - antwoordtype "Anders"',

          'TIPO_DEMOGRAFICO':'Demografische type',
          'SIN_TIPO_DEMOGRAFICO':'Geen demografische type geselecteerd voor deze vraag'

          //     {{'CERTIFICARV3.TAB_PREGUNTAS.DETALLE.ETI_LABE_DESC'|translate}}
        },
        'MSJ_MODALES':{
          'TITU_MOD_GUA_CAM_TEMP': 'Nieuw sjabloon',
          'TEXT_MOD_GUA_CAM_TEMP': 'Typ de naam voor het nieuwe sjabloon',
          'BTN_CAN_MOD_GUA_CAM_TEMP': 'Annuleren',
          'BTN_AGRE_MOD_GUA_CAM_TEMP': 'Toevoegen',
          'RETUR_MOD_GUA_CAM_TEMP': 'U hebt geen tekst voor de naam ingevoerd',
          'SUCC_TEXT_MOD_GUA_PLAN': 'Het nieuwe sjabloon is correct opgeslagen',
          'TITU_MOD_GUA_CAM_TEMP2': 'Wilt u de wijzigingen in het oorspronkelijke sjabloon opslaan? WAARSCHUWING: De volgende keer dat een product met dit sjabloon wordt toegewezen, zullen alle tot nu toe aangebrachte wijzigingen worden opgenomen',
          'BTN_CONTI_MOD_GUA_CAM_TEMP': 'Continue',
          'SUCC_TEXT_MOD_GUA_PLAN_ORG': 'Wijzigingen in het oorspronkelijke sjabloon zijn correct opgeslagen',
          'MENS_1': 'Wat voor soort vraag wil je toevoegen aan de sectie?',
          'MENS_2': 'Je hebt twee opties',
          'BTN_NEW': 'Nieuw',
          'BTN_D_CATA': 'Uit de catalogus',
          'TITU_MOD_CARG_LIS_COLAB_P1': 'Dit bestand bevat',
          'TITU_MOD_CARG_LIS_COLAB_P2': 'secties en een totaal van',
          'TITU_MOD_CARG_LIS_COLAB_P3': 'vragen.WAARSCHUWING: Als u dit bestand blijft laden, worden de vragen en groepen die u momenteel hebt, vervangen',
          'TITU_TEX_MOD_CARG_LIS_COLAB': 'U hebt twee opties',
          'BTN_AGRE_PREGU': 'Voeg de vragen toe',
          'BTN_CANC_PREGU': 'Gooi vragen weg',
          'TEXT_MOD_SUCCE_CARG_LIS_COLAB': 'Vragen zijn correct toegevoegd',
          'TEXT_MOD_NOT_CARG_LIS_COLAB': 'De vragen zijn weggegooid',
          'TEXT_MOD_ERRO_CARG_LIS_COLAB': 'Het geselecteerde bestand heeft fouten en kan niet worden geladen. Controleer nogmaals of alle rijen in de juiste volgorde zijn geplaatst en probeer het opnieuw',
          'BTN_OK': 'OK',
          'TITU_MOD_NEW_SECC': 'Nieuwe sectie',
          'TEXT_MOD_NEW_SECC': 'Voer de naam van de nieuwe sectie in',
          'TEXT_SUCC_PREG_AGRE': 'De vraag is correct toegevoegd',
          'TITU_MOD_EDI_SECC': 'Sectienaam wijzigen',
          'TEXT_SUCC_MODIF_SECC': 'Sectienaam correct gewijzigd',
          'TEXT_SUCC_MODIF_GRU':'Groepsnaam werd gewijzigd',
          'TITU_MOD_DELE_SECC1': 'Weet u zeker dat u dit onderdeel wilt verwijderen?',
          'BTN_SI': 'Ja',
          'BTN_NO': 'Nee',
          'TITU_MOD_DELE_SECC2': 'Dit gedeelte bevat één of meer vragen, wat wilt u met deze vragen doen',
          'BTN_DELE_PRE': 'Verwijder de vragen',
          'BTN_CAN_TRAN': 'Breng ze over naar de vorige sectie',
          'TEX_SUCC_DELE_PREG': 'De sectie werd correct verwijderd',
          'TITU_AGRE_NEW_PREG': 'Nieuwe vraag',
          'TEXT_AGRE_NEW_PREG': 'Voer de tekst van de nieuwe vraag in',
          'TITU_EDIT_PREG_MOD_PREG': 'Wijzig vraag',
          'TITU_EDIT_PREG_MOD_PRACT': 'Wijzig de praktijk',
          'TITU_EDIT_PREG_MOD_DESCRI': 'Beschrijving wijzigen',
          'TEXT_MOD_PREG_SUCC': 'De vraag is correct gewijzigd',
          'TITU_2_OPCIO': 'U hebt twee opties om deze wijziging op te slaan',
          'BTN_CONF_ACT':'Vraag bijwerken',
          'BTN_CANC_NEW':'Als nieuwe vraag',
          'BTN_CONF_ACT_VERSION':'Update deze versie',
          'BTN_CANC_NEW_VERSION':'Als nieuwe versie',
          'TEX_CONFIR_MSG1': 'De vraag is correct gewijzigd',
          'TEX_CONFIR_MSG2': 'Praktijk correct aangepast',
          'TEX_CONFIR_MSG3': 'De beschrijving is correct gewijzigd',
          'TITU_DELE_PREG': 'Weet u zeker dat u deze vraag wilt verwijderen?',
          'TEXT_SUCC_PREG': 'De vraag is correct verwijderd',
          'TITU_MOD_DELE_SECC_TEMPLA': 'Weet u zeker dat u dit gedeelte wilt verwijderen?',
          'TITU_MOD_DELE_SECC_TEMPLA2': 'Deze rubriek bevat één of meerdere vragen, wat wilt u met deze vragen doen?',
          'TEX_SUCC_GUAR_PREG_': 'De vraag is correct opgeslagen',
          'TITU_MOD_DELE_PREG_MG': 'Weet u zeker dat u de vraag uit de catalogus wilt verwijderen? WAARSCHUWING: Deze actie kan niet worden teruggedraaid en de vraag zal niet meer beschikbaar zijn in de sjablonen die deze nu bevatten',
          'TEX_CONFIR_MSG4_DELE': 'De vraag is correct uit de catalogus verwijderd',
          'TEX_GUAR_TRADU_SUCC': 'De vertaling is correct opgeslagen',
          'TEX_MOVE_PREG_SECC': 'Vraag verplaatst naar een andere sectie',
          'TEX_SUCC__PRAC_4ALL': 'Praktijk is correct toegevoegd',
          'MOD_MOD_AGRE_PREG': 'De vraag is correct aan de lijst toegevoegd',
          'MOD_MOD__MODIF_VERSI_PREG': 'De versie van de vraag is correct gewijzigd',
          'MOD_MOD__QUIT_PREG_LIST': 'De versie van de vraag is correct gewijzigd',
          'TITU_NUE_OPC_RESP': 'Nieuwe antwoordoptie',
          'TEXT_NUE_OPC_RESP': 'Voer tekst in voor nieuwe optie',
          'TEXT_NO_TEXT_PREG': 'U hebt geen tekst voor de vraag ingevoerd',
          'TEXT_AGRE_OPC_RESP': 'Antwoordoptie correct toegevoegd',
          'MOD_EDIT_RESP': 'Wijzig antwoordoptie',
          'MOD_EDIT_MODIF_OPC_RESP': 'De antwoordoptie is correct gewijzigd',
          'MOD_COMFIR_DELE_OPC_RESP': 'Weet u zeker dat u deze antwoordoptie wilt verwijderen?',
          'MOD_SUCC_DELE_OPC_RESP': 'De antwoordoptie is correct verwijderd',
          'MOD_NO_CONT_SIN_HAB_AGRE_OPC_RESP': 'Kan niet doorgaan zonder antwoordopties aan de vraag toe te voegen',
          'MOD_NO_CONT_SIN_HAB_ESCR_OPC_RESP': 'U kunt niet doorgaan zonder eerst de tekst van de vraag te hebben geschreven',
          'MOD_NO_CONT_SIN_HAB_ELE_TIP_RESP': 'U kunt niet doorgaan zonder het vraagtype te hebben gekozen',
          'MOD_AGRE_PREG_DONDE_GUARDAR': 'Wilt u, voordat u de nieuwe vraag toevoegt, deze in de catalogus opslaan? Of wil je het gewoon in deze enquête hebben?',
          'MOD_AGRE_PREG_DONDE_GUARDAR_INFO': 'Door het op te slaan in de catalogus, kunt u het desgewenst beschikbaar maken voor andere onderzoeken.',
          'BOT_DONDE_GUARDAR_1': 'Sla het op in de catalogus',
          'BOT_DONDE_GUARDAR_2': 'Bewaar het alleen voor deze enquête',
          'MOD_SIN_TAGS': 'U heeft nog niet ten minste één trefwoord voor de vraag ingevoerd',
          'MOD_SIN_OPC_RESP': 'U heeft voor de vraag nog niet minimaal twee antwoordmogelijkheden ingevoerd',
          'MOD_SIN_TIPO_DEMO': 'U heeft het demografische type voor deze vraag nog niet geselecteerd',
          'MOD_SIN_CLA_ESPE': 'Je hebt de sleutel nog niet toegevoegd aan de speciale vraag',
          'MOD_SIN_TIPO_RESP': 'U kunt niet doorgaan zonder het type antwoord op de vraag te selecteren',
          'MOD_RESP_DELOK': 'Antwoordoptie succesvol verwijderd',
          'MOD_RESP_DELCATOK': 'De vraag is met succes uit de catalogus verwijderd',
          'MOD_RESP_ADDTAGOK': 'Trefwoord correct toegevoegd aan vraag',
          'MOD_RESP_ADDTAGERR': 'Het trefwoord is niet begonnen met het teken #',
          'MOD_RESP_DELTAGOK': 'Het zoekwoord is correct uit de vraag verwijderd',
          'MOD_SAVE_CAMBIOS_PREGCAT': 'Bij het opslaan van wijzigingen aan deze catalogusvraag, worden de aangebrachte wijzigingen opgeslagen als nieuwe versies van de vraagteksten en eventuele antwoordmogelijkheden.\n\nwil je doorgaan?',
          'MOD_SAVE_CAMB_PREGCAT': 'Waar wilt u deze wijziging in de vraagtekst opslaan?',
          'BTN_MOD_SAVE_CAMB_PREGCAT': 'Alleen in deze enquête',
          'BTN_MOD_ACTUA_PREGCAT': 'Werk de vraag bij in de catalogus',
        }
      },
      'TAB_TRADUCCION':{
        'TEX_MOD_CARG': 'Laden',
        'TEXT_NO_ELEG_ADIC': 'Geen extra talen gekozen',
        'ERR_MSG_TRADU': 'Vertaling nog niet voltooid',
        'TEX_IDIO_PRIN': 'Hoofdtaal',
        'TEX_NAM_GRUP': 'Naam van de groep',
        'TEX_TRAD_NAM': 'Voer de vertaling van de naam in',
        'TEX_NO_TRAD_TEXT': 'U heeft de vertaalde tekst niet ingevoerd!',
        'TEX_TEX_PREG': 'Vraagtekst',
        'TEX_TEX_RESP': 'Reactietekst',
        'TEX__TRA_PREG': 'Voer de vertaling van de vraag in',
        'TEX__TRA_RESP': 'Voer de vertaling van het antwoord in',
        'GUAR_TRA_NAM': 'Opslaan van de naamvertaling, even wachten a.u.b.',
        'GUAR_TRA_PRE': 'Bespaar de vertaling van de vragen, wacht even',
        'GUAR_TRA_RES': 'Besparing van de vertaling van de antwoordmogelijkheid, gelieve te wachten',
        'INGR_TEX_PRAC_4ALL': 'Praktijk',
        'INGR_TEX_TRADU_PRAC_4ALL': 'Praktijkvertaling invoeren',
        'INGR_TEX_DESCR_4ALL': 'Beschrijving',
        'INGR_TEX_TRADU_DESCR_4ALL': 'Voer de vertaling van de beschrijving in',
        'GUAR_TRADU_PRAC': 'Besparing van de praktijkvertaling, wacht even...',
        'GUAR_TRADU_DESCR': 'Opslaan beschrijving vertaling, gelieve te wachten...',

      },
      'TAB_PREVIEW':{
        'INST_SELECC_IDI': 'Selecteer een taal om de vertalingen van de vragen weer te geven',
        'ETI_SIN_TRAD_PRE': '¡De vertaalde tekst ontbreekt!'
      },
      'MODAL_AUDIO': {
        'TITULO': {
          'ADD': 'Een audiotrack toevoegen',
          'CHANGE': 'Vervang audiotrack'
        },
        'SUBTITULO': 'U kunt een audiotrack aan deze vraag koppelen via een van de volgende opties:',
        'BOTONES': {
          'RESTART': 'Terug naar start',
          'NEXT': 'Volgende',
          'BACK': 'Ga terug',
          'ACEPTAR': 'Aanvaarden',
          'CANCELAR': 'Annuleren'
        },
        'OPCIONES': {
          'GOOGLE': 'Genereer een automatische vertelling',
          'RECORD': 'Een vertelling opnemen',
          'ARCHIVO': 'Upload een mp3-bestand',
        },
        'PASOS': {
          'GOOGLE': {
            'TITULO': 'U kunt de tekst bewerken om automatische gesproken tekst te genereren',
            'INPUT': 'Vraagtekst',
            'INPUT_TT': 'Schrijf de vraagtekst',
            'NOTA': 'OPMERKING: Als u deze tekst wijzigt, wordt de vraagtekst in de enquête niet gewijzigd'
          },
          'RECORD': {
            'TITULO': 'Klik op de knop Opnemen om audio van de microfoon op te nemen',
            'NOTA': 'OPMERKING: Mogelijk moet u toestemming verlenen om de microfoon te gebruiken in de browser',
            'START': 'Beginnen met opnemen',
            'STOP': 'Audio opnemen, klik op de knop om de opname te stoppen'
          },
          'ARCHIVO': {
            'INPUT': 'Klik hier of sleep het audiobestand naar dit gebied om het te laden',
            'NOTA': 'OPMERKING: Alleen MP3-indeling wordt ondersteund'
          },
          'PREVIEW': {
            'GENERANDO': 'Er wordt geluid gegenereerd, een ogenblik geduld a.u.b.',
            'TITULO': 'Hieronder kun je de geladen audio beluisteren',
            'NOTA_1': 'Als u deze audiotrack bij de vraag wilt opslaan, klikt u op de knop OK',
            'NOTA_2': 'Als u de audio wilt wijzigen, klikt u op de knop Terug',
            'NOTA_3': 'Als u het type audio dat wordt geladen wilt wijzigen, klikt u op de knop Terug naar start'
          }
        },
        'MODALES': {
          'DESCARTAR': 'Weet u zeker dat u teruggaat naar de vorige stap? \n\n De huidige track wordt verwijderd',
          'ARCHIVO_MAL': 'Het geüploade bestand is geen audiotrack',
          'GUARDANDO': 'Audiotrack opslaan in vraag, wacht even',
          'BORRAR': 'Weet je zeker dat je de audiotrack wilt verwijderen die bij deze vraag hoort?',
          'CONFIRMAR_BORRAR': 'Om te bevestigen, voert u de rode code in het tekstvak in: \n\n',
          'BORRADO_OK': 'De audiotrack van de vraag is correct verwijderd',
          'CODIGO_MAL': 'De ingevoerde code komt niet overeen met de in rood aangegeven code',
          'AGREGANDO_PREGUNTAS': 'Geselecteerde vragen worden toegevoegd aan de sectie, even geduld a.u.b.'
        },
        'PREVIOS': {
          'TITULO': 'Bijbehorende audiotrack',
          'SIN_AUDIO': 'Er is geen bijbehorende audiotrack',
          'SIN_AUDIO_FORALL': 'Geen audiotrack',
          'ADD_AUDIO': 'Een audiotrack toevoegen',
          'CON_AUDIO': 'Deze vraag heeft een audiotrack',
          'PLAY': 'Audio afspelen',
          'CHANGE': 'Audio vervangen',
          'DELETE': 'Audio verwijderen',
          'AUDIO_STATEMENT_1': 'Audiotrack van stelling 1',
          'AUDIO_STATEMENT_2': 'Audiotrack van stelling 2',
        }
      },
      'MODAL_SEC_ESP': {
        'TITULO': 'Speciale sectie',
        'SUBTITULO_1': 'Deze groep vragen kan worden ingesteld als een speciale sectie, de vragen van deze groep worden alleen getoond aan medewerkers die hetzelfde wachtwoord hebben',
        'SUBTITULO_2': 'OPMERKING: Het is noodzakelijk dat er ten minste één bijdrager is gekoppeld aan deze speciale sectie in de uploadstap voor de bijdrager',
        'TIPOS': {
          'NORMAL': 'Normaal gedeelte',
          'ESPECIAL': 'Speciale sectie'
        },
        'CAMPO': {
          'TITULO': 'Sectiesleutel',
          'TOOLTIP': 'Schrijf de sleutel van deze sectie',
          'HINT': 'Geen spaties',
          'ACEPTAR': 'Aanvaarden'
        },
        'MODALES': {
          'CONFIRM_DISABLE': 'Als u de speciale secties uitschakelt, worden de vraaggroepen die momenteel zijn gemarkeerd als Speciale secties omgezet in normale vraaggroepen, deze wijziging is van toepassing op alle vraagsecties. \n\n Weet je zeker dat je door wilt gaan?',
          'DISABLE_OK': 'Alle gevonden speciale secties zijn geconverteerd naar normale vraaggroepen',
          'SIN_CLAVE': 'Om de speciale sectie op te slaan, moet je een sleutel voor de sectie invoeren'
        }
      }

    },
  }
};
